import config from "@/consoleapi/config";
import axios, {AxiosStatic} from 'axios'

export default class ConsoleApi {

    /**
     *
     */
    protected requestUri: string;


    protected axios: AxiosStatic;

    protected bearerToken = '';

    protected resource = '';

    /**
     *
     */
    constructor() {
        this.requestUri = config.RestAPI.Scheme + '://' + config.RestAPI.Host + config.RestAPI.CommonResource;
        this.axios = axios;
    }

    /**
     * @param accountId
     */
    protected getAccountResource(accountId: string) {
        return '/accounts/' + accountId + this.resource;
    }

    /**
     * @param bearerToken
     */
    public setBearerToken(bearerToken: string) {
        this.bearerToken = bearerToken;
    }

    public getRequestUri()
    {
        return this.requestUri;
    }
}